<template>
  <div class="container">
    <h1>Not Found 404 error <i class="fas fa-meh"></i></h1>
    <h2>Ooooooooooooooops</h2>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
* {
  color: #fff;
}
</style>